import { RouteName } from "../config/GameConfig";

export type GameSfx = "level_start" | "success" | "failure" | "prop_hint" | "prop_help" | "coin" | "click";
type MusicScene = "home" | "quiz";

export class GameAudio {
    private static readonly MUSIC_KEY = "chengyu-music-enabled";
    private static unlocked = false;
    private static musicEnabled = GameAudio.readMusicEnabled();
    private static desiredScene: MusicScene = "home";
    private static playingScene: MusicScene | "" = "";
    private static musicChannel: Laya.SoundChannel | null = null;
    private static duckVersion = 0;

    static setRoute(route: RouteName): void {
        const scene: MusicScene = route === "quiz" ? "quiz" : "home";
        this.desiredScene = scene;
        if (this.unlocked && this.musicEnabled && this.playingScene !== scene) this.startMusic(scene);
    }

    static unlock(): void {
        if (this.unlocked) return;
        this.unlocked = true;
        if (this.musicEnabled) this.startMusic(this.desiredScene);
    }

    static isMusicEnabled(): boolean {
        return this.musicEnabled;
    }

    static setMusicEnabled(enabled: boolean): void {
        this.musicEnabled = enabled;
        try {
            globalThis.localStorage?.setItem(this.MUSIC_KEY, enabled ? "1" : "0");
        } catch (_error) {
            // Music preference remains valid for the current session.
        }
        if (!enabled) {
            if (this.musicChannel) this.musicChannel.stop();
            Laya.SoundManager.stopMusic();
            this.musicChannel = null;
            this.playingScene = "";
            return;
        }
        if (this.unlocked) this.startMusic(this.desiredScene);
    }

    static playSfx(cue: GameSfx, duckMilliseconds = 800): void {
        this.unlock();
        Laya.SoundManager.playSound(`resources/audio/game/${cue}.mp3`, 1);
        if (duckMilliseconds <= 0) return;
        const version = ++this.duckVersion;
        if (this.musicEnabled) Laya.SoundManager.musicVolume = 0.16;
        Laya.timer.once(duckMilliseconds, this, () => {
            if (version === this.duckVersion && this.musicEnabled) Laya.SoundManager.musicVolume = 0.34;
        });
    }

    private static startMusic(scene: MusicScene): void {
        if (!this.musicEnabled) return;
        if (this.musicChannel) this.musicChannel.stop();
        Laya.SoundManager.musicVolume = 0.34;
        this.musicChannel = Laya.SoundManager.playMusic(`resources/audio/game/bgm_${scene}.mp3`, 0);
        this.playingScene = scene;
    }

    private static readMusicEnabled(): boolean {
        try {
            return globalThis.localStorage?.getItem(this.MUSIC_KEY) !== "0";
        } catch (_error) {
            return true;
        }
    }
}
